
import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const getNewInstituteListApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}institute/new-institute-dtrf`,
        method: "get",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default getNewInstituteListApi
